import dynamic from "next/dynamic";

export const ReviewCard = dynamic(() => import("./component"));
